/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/yin-yang-1408701': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 15.5a1 1 0 101 1 1 1 0 00-1-1zM12 2a5.545 5.545 0 00-.562.029A9.993 9.993 0 0012 22a5.545 5.545 0 00.562-.029A9.993 9.993 0 0012 2zm0 18A7.989 7.989 0 016.71 6.015 5.484 5.484 0 0012 13a3.5 3.5 0 010 7zm5.29-2.015A5.484 5.484 0 0012 11a3.5 3.5 0 010-7 7.989 7.989 0 015.29 13.985zM12 6.5a1 1 0 101 1 1 1 0 00-1-1z"/>'
  }
})
